module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-next-seo@1.11.0_gatsby@5.16.1_@babel+plugin-syntax-flow@7.27.1_@babel+cor_3ff94bd85b2321aa747e3e7a7bf14bc2/node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-plugin-thumbor/gatsby-browser.js'),
      options: {"plugins":[],"breakpoints":[768,1280,1920]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-tagmanager@5.14.0_gatsby@5.16.1_@babel+plugin-syntax-flow@7.27.1_@_0d1ab3a28871544179951985c8913716/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KWZFNV8","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"routeChangeEventName":"gatsby-route-change","enableWebVitalsTracking":false,"selfHostedOrigin":"https://www.googletagmanager.com","selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_@babel+plugin-syntax-flow@7.27.1_@babel+core@7.28.0__@babel+plugin-transf_54c4d36269719523a81a66ad192f15bb/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
